const Section2 = () => {
  return (
    <section className="bg-white space-y-4 py-16 px-6 md:px-12">
      <div className="flex flex-col mt-16 ml-0 lg:ml-20 lg:flex-row items-center justify-between">
        {/* Left Section */}
        <div className="lg:w-1/2 relative mt-6 lg:mt-0 flex justify-center items-start">
          <div className="relative lg:w-[230px] lg:h-[350px] md:w-[180px] md:h-[400px] sm:w-[150px] sm:h-[320px]">
            {/* Background image */}
            <img
              src="./ruj.png"
              alt="Section 2 Background"
              className="absolute 
                 lg:top-[-96px] lg:left-[-200px] 
                 md:top-[12px] md:left-[-120px] 
                 sm:top-[-80px] sm:left-[-80px] 
                 w-full h-full object-cover"
            />

            {/* Square image */}
            <div
              className="absolute z-10 
                    lg:w-[290px] lg:h-[240px] lg:top-[-99px] lg:left-[46px] 
                    md:w-[200px] md:h-[200px] md:top-[-45px] md:left-[45px] 
                    sm:w-[160px] sm:h-[160px] sm:top-[-90px] sm:left-[81px]"
            >
              <img
                src="./ruk.png"
                alt="Thumb 2"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Thumb 4 image */}
            <div
              className="absolute z-10 
                    lg:w-[318px] lg:h-[390px] lg:bottom-[-86px] lg:left-[46px] 
                    md:w-[250px] md:h-[300px] md:bottom-[-65px] md:left-[45px] 
                    sm:w-[200px] sm:h-[200px] sm:bottom-[36px] sm:left-[81px]"
            >
              <img
                src="./rul.png"
                alt="Thumb 4"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Graduation cap */}
            <div
              className="absolute z-40 
                    lg:w-[77px] lg:h-[80px] lg:top-[-34px] lg:left-[-246px] 
                    md:w-[60px] md:h-[65px] md:top-[-25px] md:left-[-180px] 
                    sm:w-[50px] sm:h-[55px] sm:top-[-117px] sm:left-[-120px]"
            >
              <img
                src="./Grad.png"
                alt="Graduation cap"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="lg:w-1/2 text-center lg:text-left space-y-5 lg:ml-20">
          {/* About us */}
          <div className="flex items-center justify-center lg:justify-start space-x-2">
            <img
              src="./sphere.png"
              alt="About Us"
              className="h-[17px] w-[23px]"
            />
            <h2 className="text-base font-semibold font-raleway text-orange-400">
              About Us
            </h2>
          </div>

          <h1 className="text-3xl md:text-4xl lg:text-5xl font-normal font-Anton text-orange-900 leading-tight">
            Benefit from our digital <br /> learning expertise and <br />{" "}
            skilled strategies for the <br />
            success for all female health <br /> workers
          </h1>

          <p className="text-sm font-normal font-raleway text-gray-800">
            Learn & Grow your skills from anywhere
          </p>

          {/* Mission & Vision */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
            {/* Mission */}
            <div className="space-y-4">
              <h3 className="text-base font-semibold font-raleway text-orange-900">
                OUR MISSION:
              </h3>
              <p className="text-sm font-normal font-raleway text-gray-800">
                Deliver structured, interactive learning <br /> content through
                pictures, videos, <br />
                animations and voiceovers, guiding <br /> learners on
                identifying, preventing and <br />
                reporting illnesses.
              </p>

              <div className="flex justify-center lg:justify-start mt-4">
                {/* <a
                  href="https://drive.google.com/drive/folders/1HbuI8Wt-NfSr92fhXN1cCzrVoeRriAzs?usp=sharing"
                  target="_blank"
                  className="hidden lg:flex bg-orange-500 hover:bg-orange-600 font-raleway text-white text-sm px-5 py-3 rounded-md items-center space-x-5"
                >
                  Download Now
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1999_5581)">
                      <path
                        d="M10.26 0C15.917 0 20.5 4.477 20.5 10C20.5 15.523 15.916 20 10.26 20C7.069 20 4.118 18.563 2.19 16.154C2.13595 16.0867 2.09598 16.0093 2.07246 15.9262C2.04894 15.8432 2.04234 15.7563 2.05307 15.6706C2.0638 15.585 2.09163 15.5024 2.1349 15.4277C2.17818 15.3531 2.23603 15.2879 2.305 15.236C2.44565 15.129 2.62243 15.0809 2.7979 15.102C2.97336 15.1231 3.13372 15.2117 3.245 15.349C4.08843 16.3972 5.15709 17.2421 6.37168 17.8208C7.58627 18.3995 8.91559 18.6973 10.261 18.692C15.176 18.692 19.161 14.8 19.161 10C19.161 5.2 15.176 1.308 10.261 1.308C8.9348 1.30283 7.62398 1.59213 6.42315 2.15502C5.22232 2.71791 4.16142 3.54035 3.317 4.563C3.20396 4.69904 3.04236 4.78569 2.86648 4.80454C2.69061 4.8234 2.51431 4.77299 2.375 4.664C2.30663 4.61123 2.24956 4.54524 2.20721 4.46997C2.16486 4.39469 2.13808 4.31167 2.12847 4.22583C2.11886 4.14 2.12662 4.05311 2.15127 3.97033C2.17593 3.88756 2.21699 3.81059 2.272 3.744C4.203 1.394 7.114 0 10.26 0ZM10.806 6.862L13.513 9.569C13.775 9.831 13.78 10.249 13.524 10.505L10.88 13.15C10.8179 13.2111 10.7444 13.2593 10.6636 13.2919C10.5828 13.3244 10.4963 13.3407 10.4092 13.3396C10.3221 13.3386 10.2361 13.3204 10.156 13.2859C10.076 13.2515 10.0036 13.2016 9.943 13.139C9.88051 13.0783 9.83065 13.0059 9.7963 12.9258C9.76195 12.8457 9.74379 12.7597 9.74286 12.6726C9.74193 12.5855 9.75825 12.4991 9.79089 12.4183C9.82352 12.3375 9.87182 12.264 9.933 12.202L11.48 10.654L1.17 10.655C1.08291 10.6563 0.996417 10.6404 0.915512 10.6081C0.834606 10.5759 0.760887 10.5279 0.698604 10.467C0.636321 10.4061 0.586706 10.3335 0.55262 10.2534C0.518533 10.1732 0.50065 10.0871 0.5 10C0.5 9.639 0.8 9.346 1.17 9.346H11.438L9.88 7.787C9.81751 7.72631 9.76765 7.65385 9.7333 7.5738C9.69895 7.49375 9.68079 7.40769 9.67986 7.32058C9.67893 7.23348 9.69525 7.14705 9.72789 7.06628C9.76052 6.98552 9.80882 6.91201 9.87 6.85C9.93204 6.78919 10.0055 6.74122 10.0861 6.70885C10.1667 6.67648 10.2529 6.66034 10.3398 6.66136C10.4267 6.66238 10.5125 6.68054 10.5923 6.7148C10.6721 6.74906 10.7444 6.79874 10.805 6.861"
                        fill="#FDF1E9"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1999_5581">
                        <rect
                          width="20"
                          height="20"
                          fill="white"
                          transform="translate(0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </a> */}
              </div>
            </div>

            {/* Vision */}
            <div className="space-y-3">
              <h3 className="text-base font-semibold font-raleway text-orange-900">
                OUR VISION:
              </h3>
              <p className="text-sm font-normal font-raleway text-gray-800">
                Empowering Frontline Community <br /> Health Workers to deliver
                exceptional <br /> care through continuous learning and <br />{" "}
                professional growth, fostering a culture <br /> of excellence,
                innovation and <br /> compassion that improves health <br />{" "}
                outcomes and transforms communities.
              </p>
            </div>

            <div className="flex justify-center lg:justify-start mt-4">
              {/* <a
                href="https://drive.google.com/drive/folders/1HbuI8Wt-NfSr92fhXN1cCzrVoeRriAzs?usp=sharing"
                target="_blank"
                className="flex lg:hidden bg-orange-500 hover:bg-orange-600 font-raleway text-white text-sm px-5 py-3 rounded-md items-center space-x-7"
              >
                Download Now
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1999_5581)">
                    <path
                      d="M10.26 0C15.917 0 20.5 4.477 20.5 10C20.5 15.523 15.916 20 10.26 20C7.069 20 4.118 18.563 2.19 16.154C2.13595 16.0867 2.09598 16.0093 2.07246 15.9262C2.04894 15.8432 2.04234 15.7563 2.05307 15.6706C2.0638 15.585 2.09163 15.5024 2.1349 15.4277C2.17818 15.3531 2.23603 15.2879 2.305 15.236C2.44565 15.129 2.62243 15.0809 2.7979 15.102C2.97336 15.1231 3.13372 15.2117 3.245 15.349C4.08843 16.3972 5.15709 17.2421 6.37168 17.8208C7.58627 18.3995 8.91559 18.6973 10.261 18.692C15.176 18.692 19.161 14.8 19.161 10C19.161 5.2 15.176 1.308 10.261 1.308C8.9348 1.30283 7.62398 1.59213 6.42315 2.15502C5.22232 2.71791 4.16142 3.54035 3.317 4.563C3.20396 4.69904 3.04236 4.78569 2.86648 4.80454C2.69061 4.8234 2.51431 4.77299 2.375 4.664C2.30663 4.61123 2.24956 4.54524 2.20721 4.46997C2.16486 4.39469 2.13808 4.31167 2.12847 4.22583C2.11886 4.14 2.12662 4.05311 2.15127 3.97033C2.17593 3.88756 2.21699 3.81059 2.272 3.744C4.203 1.394 7.114 0 10.26 0ZM10.806 6.862L13.513 9.569C13.775 9.831 13.78 10.249 13.524 10.505L10.88 13.15C10.8179 13.2111 10.7444 13.2593 10.6636 13.2919C10.5828 13.3244 10.4963 13.3407 10.4092 13.3396C10.3221 13.3386 10.2361 13.3204 10.156 13.2859C10.076 13.2515 10.0036 13.2016 9.943 13.139C9.88051 13.0783 9.83065 13.0059 9.7963 12.9258C9.76195 12.8457 9.74379 12.7597 9.74286 12.6726C9.74193 12.5855 9.75825 12.4991 9.79089 12.4183C9.82352 12.3375 9.87182 12.264 9.933 12.202L11.48 10.654L1.17 10.655C1.08291 10.6563 0.996417 10.6404 0.915512 10.6081C0.834606 10.5759 0.760887 10.5279 0.698604 10.467C0.636321 10.4061 0.586706 10.3335 0.55262 10.2534C0.518533 10.1732 0.50065 10.0871 0.5 10C0.5 9.639 0.8 9.346 1.17 9.346H11.438L9.88 7.787C9.81751 7.72631 9.76765 7.65385 9.7333 7.5738C9.69895 7.49375 9.68079 7.40769 9.67986 7.32058C9.67893 7.23348 9.69525 7.14705 9.72789 7.06628C9.76052 6.98552 9.80882 6.91201 9.87 6.85C9.93204 6.78919 10.0055 6.74122 10.0861 6.70885C10.1667 6.67648 10.2529 6.66034 10.3398 6.66136C10.4267 6.66238 10.5125 6.68054 10.5923 6.7148C10.6721 6.74906 10.7444 6.79874 10.805 6.861"
                      fill="#FDF1E9"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1999_5581">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section2;
